import { useEffect } from "react";
import { AuthUser, UserMedspa } from "@/auth/useAuthState";
import { Datadog } from "@/utils/observability/datadog";

export function useTracking(user: AuthUser, userMedspa: UserMedspa) {
  useEffect(() => {
    if (user) {
      Datadog.setUserFromAuth(user);
    } else {
      Datadog.clearUser();
    }
  }, [user]);

  useEffect(() => {
    if (userMedspa) {
      Datadog.setMedspaId(userMedspa.medspa.id);
    } else {
      Datadog.clearMedspaId();
    }
  }, [userMedspa]);
}
